import React from "react"
import {OrgSettingsLayout} from "@/features/org-settings"

function Settings() {
  return <OrgSettingsLayout />
}

export default Settings
